import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";

export default class ProductMigration extends BaseInstitutionEntity {
    name: string = '';
    fromProduct: EntityIdentifier = new EntityIdentifier();
    fromProductIssue: EntityIdentifier = new EntityIdentifier();
    toProduct: EntityIdentifier = new EntityIdentifier();
    toProductIssue: EntityIdentifier = new EntityIdentifier();
    createdAtUtc: Date = new Date();
    status: string = '';
    pendingAccounts: number = 0;
    failedAccounts: number = 0;
    migratedAccounts: number = 0;
    totalAccounts: number = 0;
    migrationDate: Date = new Date();
}